"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _createForOfIteratorHelper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultVideoStreamIdSet_1 = require("../videostreamidset/DefaultVideoStreamIdSet");
/**
 * [[AllHighestVideoBandwidthPolicy]] implements is a rudimentary policy that simply
 * always subscribes to the highest quality video stream available
 * for all non-self participants.
 */


var AllHighestVideoBandwidthPolicy = /*#__PURE__*/function () {
  function AllHighestVideoBandwidthPolicy(selfAttendeeId) {
    _classCallCheck(this, AllHighestVideoBandwidthPolicy);

    this.selfAttendeeId = selfAttendeeId;
    this.reset();
  }

  _createClass(AllHighestVideoBandwidthPolicy, [{
    key: "reset",
    value: function reset() {
      this.optimalReceiveSet = new DefaultVideoStreamIdSet_1.default();
      this.subscribedReceiveSet = new DefaultVideoStreamIdSet_1.default();
      this.videoSources = undefined;
    }
  }, {
    key: "updateIndex",
    value: function updateIndex(videoIndex) {
      this.videoIndex = videoIndex;
      this.optimalReceiveSet = this.calculateOptimalReceiveSet(videoIndex);
    }
  }, {
    key: "updateMetrics",
    value: function updateMetrics(_clientMetricReport) {}
  }, {
    key: "wantsResubscribe",
    value: function wantsResubscribe() {
      return !this.subscribedReceiveSet.equal(this.optimalReceiveSet);
    }
  }, {
    key: "chooseSubscriptions",
    value: function chooseSubscriptions() {
      this.subscribedReceiveSet = this.optimalReceiveSet.clone();
      return this.subscribedReceiveSet.clone();
    }
  }, {
    key: "chooseRemoteVideoSources",
    value: function chooseRemoteVideoSources(videoSources) {
      this.videoSources = videoSources;
      this.optimalReceiveSet = this.calculateOptimalReceiveSet(this.videoIndex).clone();
    }
  }, {
    key: "calculateOptimalReceiveSet",
    value: function calculateOptimalReceiveSet(videoIndex) {
      var streamSelectionSet = new DefaultVideoStreamIdSet_1.default();

      if (!this.videoIndex || this.videoIndex.allStreams().empty()) {
        return streamSelectionSet;
      }

      var receiveSet = videoIndex.highestQualityStreamFromEachGroupExcludingSelf(this.selfAttendeeId); // If video sources are not chosen, then return the default receive set.

      if (this.videoSources === undefined) {
        return receiveSet;
      } // Get the list of all the remote stream information


      var remoteInfos = this.videoIndex.remoteStreamDescriptions();
      var mapOfAttendeeIdToOptimalStreamId = new Map();

      var _iterator = _createForOfIteratorHelper(remoteInfos),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var info = _step.value;

          if (receiveSet.contain(info.streamId)) {
            mapOfAttendeeIdToOptimalStreamId.set(info.attendeeId, info.streamId);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(this.videoSources),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var videoSource = _step2.value;
          var attendeeId = videoSource.attendee.attendeeId;

          if (mapOfAttendeeIdToOptimalStreamId.has(attendeeId)) {
            streamSelectionSet.add(mapOfAttendeeIdToOptimalStreamId.get(attendeeId));
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return streamSelectionSet;
    }
  }]);

  return AllHighestVideoBandwidthPolicy;
}();

exports.default = AllHighestVideoBandwidthPolicy;